import React, { Component } from 'react';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import FrontNav from '../../../components/FrontNav';
import TabNav from '../../../components/TabNav';
import ProjectSearchList from '../../../components/Activity/Project/ProjectSearchList';

class ScreenProjectsSearchList extends Component {
	render () {
		return (
			<section>
				<Header />
				<FrontNav match={this.props.match} />
				<TabNav match={this.props.match} />
			    <ProjectSearchList id={this.props.match.params.id} props={this.props} />
			    <Footer />
			</section>
		)
	}
}

export default ScreenProjectsSearchList;